// removed by extract-text-webpack-plugin
module.exports = {"third-step-container":"third-step__third-step-container__16NSu","option-wrapper":"third-step__option-wrapper__8hvHx","add-button-wrapper":"third-step__add-button-wrapper__1Ne8u","quantity-switch-wrapper":"third-step__quantity-switch-wrapper__2EB0g","quantity-label":"third-step__quantity-label__3pyJH","button-wrapper":"third-step__button-wrapper__1bu_8","button-inner":"third-step__button-inner__1BrqU"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/time-poll/TimePollContainer/SignUp/CreateSignUp/ThirdStep/third-step.scss
// module id = 1789
// module chunks = 1